<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
import axios from "axios";
import server from "./server";

export default {
	mounted() {

	}
}
</script>

<style lang="less">
html, body {
	width: 100%;
	height: 100%;
	margin: 0;
   padding: 0;
   background-color: #F7F7F7;   
}

#app {
	margin: 0 auto;
   width: 80%;
   max-width: 1600px;   
   @media only screen and (hover: none) and (pointer: coarse){
      width: 100%;
      height: 100%;
   }

}
</style>
